import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AlreadyAddedValuesPipeModule } from 'lu-already-added-values-pipe';
import { LuIconModule } from 'lu-icon';
import { LuInfiniteScrollModule } from 'lu-infinite-scroll-directive';
import { SearchPipeModule } from 'lu-search-pipe';
import { DataService, ScrollService } from 'lu-services';
import { LuTypeaheadChipLabelComponent } from './lu-typeahead-chip-label/lu-typeahead-chip-label.component';
import { LuTypeaheadChipWrapperComponent } from './lu-typeahead-chips/lu-typeahead-chip-wrapper';
import { LuTypeaheadItemTitleLabelComponent } from './lu-typeahead-item-title-label/lu-typeahead-item-title-label.component';
import { LuTypeaheadItemWrapperComponent } from './lu-typeahead-items/lu-typeahead-item-wrapper';

import { GetSearchInputAriaLabelPipe } from 'src/app/angie-shared/libs/lu-typeahead/pipes/get-search-input-aria-label.pipe';
import { LuTypeaheadComponent } from './lu-typeahead.component';
import { dataService, LuTypeaheadModuleConfig, scrollService } from './lu-typeahead.models';

export const entryComponents = [LuTypeaheadItemTitleLabelComponent, LuTypeaheadChipLabelComponent];

@NgModule({
	imports: [
		FormsModule,
		CommonModule,
		LuIconModule,
		LuInfiniteScrollModule,
		TranslateModule,
		AlreadyAddedValuesPipeModule,
		SearchPipeModule,
		GetSearchInputAriaLabelPipe
	],
	declarations: [
		...entryComponents,
		LuTypeaheadComponent,
		LuTypeaheadItemWrapperComponent,
		LuTypeaheadChipWrapperComponent
	],
	exports: [LuTypeaheadComponent, ...entryComponents]
})
export class LuTypeaheadModule {
	static forRoot(config: LuTypeaheadModuleConfig = {}): ModuleWithProviders<LuTypeaheadModule> {
		return {
			ngModule: LuTypeaheadModule,
			providers: [
				config.dataService || {
					provide: dataService,
					useClass: DataService
				},
				config.scrollService || {
					provide: scrollService,
					useClass: ScrollService
				}
			]
		};
	}
}
